import './LoaderAboutMovie.scss'

export const LoaderAboutMovie = () => {

    return (
        <div className='skeleton-about'>
            <ul className="skeleton-about__list">
            <li className='skeleton-about__item'></li>
            <li className='skeleton-about__item'></li>
            <li className='skeleton-about__item'></li>
            <li className='skeleton-about__item'></li>
            </ul>
        </div>

    )
}

